import React, { useState, useEffect } from "react";
import Header from "../ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../Assets/Images/sm-Circle.svg";
import ContentHead from "./Components/ContentHead";
import "../../../../Assets/Styles/Vacancies.scss";
import JobItem from "./Components/SharedElements/JobItem";
import ImagePreloader from "../ShareElements/ImagePreloader/ImagePreloader";
import BookmarkPlus from "../../../../Assets/Images/bookmark-plus.svg";
import BookmarkedIcon from "../../../../Assets/Images/Bookmarked-item.svg";
import Select from "../ShareElements/Select/Select";
import { Config } from "../../../../Config";
import axios from "axios";
import EmptyState from "../ShareElements/EmptyState/FormEmptyState";
import TrashIcon from "../../../../Assets/Images/trash-2.svg";
import TrashIconRed from "../../../../Assets/Images/trash-2-red.svg";

const Vacancies = (props) => {
  const [PageInfo, setPageInfo] = useState({
    FirstPage: 1,
    FirstDotsShown: false,
    MiddlePage: 3,
    LastDotsShown: false,
    LastPage: 7,
    ActivePage: 1,
  });
  const [StatusOptions, setStatuses] = useState([]);
  const [Pages, setPages] = useState([]);
  const [PrevFilters, setPrevFilters] = useState({});
  const [SizeOptions] = useState([
    { name: 6, id: 6 },
    { name: 9, id: 9 },
    { name: 12, id: 12 },
  ]);
  const [TotalElements, setTotalElements] = useState(16);
  const [ResIsEmpty, setResIsEmpty] = useState(false);
  const [JPAs, setJPAs] = useState([]);
  const [SavedJPAs, setSavedJPAs] = useState([]);
  const [ResBookmarkedIsEmpty, setResBookmarkedIsEmpty] = useState(false);
  const [NoItems, setNoItems] = useState(false); // to check if there are any items for this user to display the related empty state

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchJPAs(6, 0, "", [], [], [], null, "initial");
    fetchSavedItems(0, 6, true);
    fetchStatuses();
    window.localStorage.removeItem("TempChatroom");
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  // Possible values defined:
  // NOT_STARTED, IN_PROGRESS, ACCEPTED, POPULAR, NEW
  const fetchStatuses = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recruitment/search/recruitment-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        var AvailableStatuses = [];
        Res.data.map((Item) => {
          if (Item === "NOT_STARTED") {
            AvailableStatuses.push(translateText("not_started"));
          } else if (Item === "IN_PROGRESS") {
            AvailableStatuses.push(translateText("in_progress"));
          } else if (Item === "ACCEPTED") {
            AvailableStatuses.push(translateText("jpa_status_accepted"));
          } else if (Item === "POPULAR") {
            AvailableStatuses.push(translateText("popular"));
          } else if (Item === "NEW") {
            AvailableStatuses.push(translateText("new"));
          }
        });
        setStatuses(AvailableStatuses);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchSavedItems = (Start, Size, IsInitial) => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recruitment/search/bookmark",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        size: Size,
        start: Start,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setSavedJPAs([]);
        setSavedJPAs(Res.data.results);
        createPagination(Res.data.totalElements, Size);
        if (!IsInitial) {
          handleDisplayDataRange(Res.data.totalElements, Size, Start);
          setTotalElements(Res.data.totalElements);
        }

        if (Res.data.results.length === 0) {
          setResBookmarkedIsEmpty(true);
        } else {
          setResBookmarkedIsEmpty(false);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchJPAs = (
    Size,
    Start,
    TitleLike,
    StatusList,
    Locations,
    SkillsList,
    SelectedDate,
    IsInitial
  ) => {
    setPrevFilters({
      size: Size,
      start: Start,
      titleLike: TitleLike,
      statusList: StatusList,
      locationList: Locations,
      skillList: SkillsList,
      selectedDate: SelectedDate,
    });
    let Data = {
      criteria: {
        titleLike: TitleLike,
        cityList: Locations,
        skillList: SkillsList,
        statusList: StatusList,
      },
      size: Size,
      start: Start,
      sorts: [
        {
          direction: "ASC",
          fieldName: "title",
        },
      ],
    };

    if (SelectedDate !== null && SelectedDate !== undefined) {
      Data.criteria.minCreatedTime = SelectedDate.startTimestamp;
      Data.criteria.maxCreatedTime = SelectedDate.endTimestamp;
    } else {
      delete Data.criteria.maxCreatedTime;
      delete Data.criteria.minCreatedTime;
    }

    if (StatusList.length === 0) {
      delete Data.criteria.statusList;
    }

    if (Locations.length === 0) {
      delete Data.criteria.cityList;
    }

    if (SkillsList.length === 0) {
      delete Data.criteria.skillList;
    }
    if (TitleLike.length === 0) {
      Data.criteria.titleLike = document.getElementById("search-input").value;
    }

    if (Data.criteria === {}) {
      Data.criteria = null;
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/recruitment/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setJPAs([]);
        setJPAs(Res.data.results);
        setTotalElements(Res.data.totalElements);
        createPagination(Res.data.totalElements, Size);
        handleDisplayDataRange(Res.data.totalElements, Size, Start);
        if (Res.data.results.length === 0) {
          setResIsEmpty(true);
          if (IsInitial === "initial") {
            setNoItems(true);
          } else {
            if (!NoItems) {
              setNoItems(false);
            }
          }
        } else {
          setResIsEmpty(false);
        }

        setTimeout(() => {
          window.localStorage.removeItem("notification_jpa_title");
        }, 300);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const handleDisplayDataRange = (totalElements, Size, Start) => {
    if (totalElements < Size) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
    if (Start === 0) {
      document.getElementById("prev-page").classList.add("page-btn-disabled");
      document.getElementById("start").innerHTML = "1";
      document.getElementById("end").innerHTML = Size;
      updateActiveClass(1);
    }
    if (totalElements > Start) {
      document.getElementById("end").innerHTML = Start + Size;
    }
    if (parseInt(Start + Size) > totalElements) {
      document.getElementById("end").innerHTML = totalElements;
    }
  };

  const createPagination = (TotalCount, Size) => {
    let Count = Math.ceil(TotalCount / Size);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };

  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };

  const searchByFilters = (
    TitleLike,
    StatusList,
    Locations,
    SkillsList,
    SelectedDate
  ) => {
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    if (!Size) {
      Size = 6;
    }

    let SkillIDs = [];
    SkillsList.map((Skill) => {
      SkillIDs.push(Skill.id);
    });

    fetchJPAs(
      Size,
      0,
      TitleLike,
      StatusList,
      Locations,
      SkillIDs,
      SelectedDate
    );
  };
  const handleSizeChange = () => {
    requestPageNumber(1);
    updateActiveClass(1);
  };
  const displaySavedItems = () => {
    if (
      !document.getElementById("saved-switch-holder").classList.contains("off")
    ) {
      let Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
      fetchSavedItems(0, Size);
      if (!ResIsEmpty) {
        document.getElementById("all-items").style.display = "none";
        document.getElementById("saved-items").classList.add("translate-top");
        document.getElementById("saved-items").style.display = "flex";
      }
      setTimeout(() => {
        if (!ResIsEmpty) {
          document
            .getElementById("saved-items")
            .classList.remove("translate-top");
        }
      }, 400);
    } else {
      if (!ResIsEmpty) {
        document.getElementById("all-items").style.display = "flex";
        document.getElementById("all-items").classList.add("translate-top");
        setTimeout(() => {
          document
            .getElementById("all-items")
            .classList.remove("translate-top");
          requestPageNumber(1);
        }, 400);
        document.getElementById("saved-items").style.display = "none";
      }
    }
  };
  const updateSavedItems = () => {};

  const requestPageNumber = (PageNumber) => {
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let NewStart = parseInt((PageNumber - 1) * Size);
    if (document.getElementById("saved-switch-holder").classList.length <= 1) {
      fetchSavedItems(NewStart, Size);
    } else {
      fetchJPAs(
        Size,
        NewStart,
        PrevFilters.titleLike,
        PrevFilters.statusList,
        PrevFilters.locationList,
        PrevFilters.skillList,
        PrevFilters.selectedDate
      );
    }

    if (NewStart === 0) {
      document.getElementById("start").innerHTML = 1;
    } else {
      document.getElementById("start").innerHTML = NewStart + 1;
    }
    handleDisplayDataRange(TotalElements, Size, NewStart);
    if (PageNumber === 1) {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
    updateActiveClass(PageNumber);
  };
  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    if (document.getElementById(PageNumber + "-page-btn") !== null) {
      document
        .getElementById(PageNumber + "-page-btn")
        .classList.add("active-page");
    }
    let PagesArray = [...Pages];
    if (PageNumber === 1) {
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    } else if (PageNumber === PagesArray.pop()) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    } else if (PageNumber === PagesArray[0]) {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    } else {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
  };
  const requestNextPage = () => {
    let NextPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          NextPage = parseInt(i + 1);
        }
      }
    }
    if (document.getElementById(NextPage + "-page-btn") !== null) {
      document.getElementById(NextPage + "-page-btn").click();
    }
  };
  const requestPrevPage = () => {
    let PrevPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          if (i === 1) {
            PrevPage = 1;
          } else {
            PrevPage = parseInt(i - 1);
          }
        }
      }
    }
    if (document.getElementById(PrevPage + "-page-btn") !== null) {
      document.getElementById(PrevPage + "-page-btn").click();
    }
  };
  const resetFilters = () => {
    if (document.getElementById("clear-btn") !== null) {
      document.getElementById("clear-btn").click();
    }
    if (document.getElementById("status-clear") !== null) {
      document.getElementById("status-clear").click();
    }
    if (document.getElementById("location-clear") !== null) {
      document.getElementById("location-clear").click();
    }
    setTimeout(() => {
      if (document.getElementById("search-select-clear") !== null) {
        document.getElementById("search-select-clear").click();
      }
    }, 150);

    if (document.getElementById("saved-switch-holder").classList.length === 1) {
      document.getElementById("saved-switch-holder").click();
    }

    if (document.getElementById("displayed-date") !== null) {
      document.getElementById("displayed-date").innerHTML =
        translateText("date_from_to");
    }

    if (document.getElementById("saved-switch-holder").classList.length === 1) {
      document.getElementById("saved-switch-holder").click();
    }

    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    setPrevFilters({});

    fetchJPAs(Size, 0, "", [], [], [], null);
  };
  const clickActivePage = () => {
    // this function refreshesh the page data which might in some cases result
    // in different status filters(the updated filters), therefore status list is updated here as well
    fetchStatuses();

    Pages.map((Page) => {
      if (
        document
          .getElementById(Page + "-page-btn")
          .classList.contains("active-page")
      ) {
        document.getElementById(Page + "-page-btn").click();
      }
    });
  };
  const refreshPageData = () => {
    clickActivePage();
  };
  return (
    <div className="main-content vacancies-wrapper">
      <ImagePreloader
        Images={[BookmarkPlus, BookmarkedIcon, TrashIcon, TrashIconRed]}
      />
      <Header PageName={translateText("vacancies")} />
      <div className="content-header">
        <div className="address">
          <p>{translateText("jobs")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("vacancies")}</p>
        </div>
      </div>
      <ContentHead
        LangData={props.LangData}
        StatusOptions={StatusOptions}
        DisplaySavedItems={() => displaySavedItems()}
        UpdateSaveItems={() => updateSavedItems()}
        SearchByFilters={(
          TitleLike,
          StatusList,
          Locations,
          SkillsList,
          SelectedDate
        ) =>
          searchByFilters(
            TitleLike,
            StatusList,
            Locations,
            SkillsList,
            SelectedDate
          )
        }
      />
      {ResIsEmpty ? (
        <React.Fragment>
          {NoItems ? (
            <EmptyState
              ResetFilters={() => resetFilters()}
              Message={translateText("no_jobs_info_text")}
              ActionButton={null}
            />
          ) : (
            <EmptyState
              ResetFilters={() => resetFilters()}
              Message={translateText("no_jobs_info_text")}
            />
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div
            className={JPAs.length < 3 ? "content-body" : "content-body"}
            id="all-items"
          >
            {JPAs.map((Job) => (
              <JobItem
                Item={Job}
                LangData={props.LangData}
                ToggleRefreshData={() => refreshPageData()}
              />
            ))}
          </div>
          <div
            className={JPAs.length < 3 ? "content-body" : "content-body"}
            id="saved-items"
          >
            {SavedJPAs.map((Job) => (
              <JobItem
                Item={Job}
                LangData={props.LangData}
                ToggleRefreshData={() => refreshPageData()}
              />
            ))}
          </div>
        </React.Fragment>
      )}
      <div
        className={
          ResIsEmpty ? "hidden" : "content-pagination vacancies-pagination"
        }
      >
        <div className="info-footer" id="info-footer">
          <div className="pagenumber-summary">
            {translateText("showing")} <p id="start">1</p>
            {translateText("to")} <p id="end">5</p>
            {translateText("of")} {TotalElements} {translateText("items")}.
          </div>
          <section className="pagination-holder">
            <button
              onClick={() => requestPrevPage()}
              id="prev-page"
              className="page-btn page-btn-disabled"
            >
              <i className="feather-chevron-left"></i>
            </button>
            <React.Fragment>
              {Pages.length < 6 ? (
                <React.Fragment>
                  {Pages.map((Page) => (
                    <React.Fragment>
                      {Page === 1 ? (
                        <button
                          key={Page}
                          onClick={() => requestPageNumber(Page)}
                          className="page-btn active-page"
                          id={Page + "-page-btn"}
                        >
                          {Page}
                        </button>
                      ) : (
                        <button
                          key={Page}
                          onClick={() => requestPageNumber(Page)}
                          className="page-btn"
                          id={Page + "-page-btn"}
                        >
                          {Page}
                        </button>
                      )}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <button
                    onClick={() => requestPageNumber(1)}
                    className="page-btn active-page"
                    id={1 + "-page-btn"}
                  >
                    {1}
                  </button>
                  {PageInfo.FirstDotsShown ? <p>...</p> : null}
                  <button
                    onClick={() =>
                      requestPageNumber(parseInt(PageInfo.MiddlePage - 1))
                    }
                    className="page-btn"
                    id={parseInt(PageInfo.MiddlePage - 1) + "-page-btn"}
                  >
                    {parseInt(PageInfo.MiddlePage - 1)}
                  </button>
                  {PageInfo.MiddlePage === PageInfo.LastPage ? null : (
                    <button
                      onClick={() => requestPageNumber(PageInfo.MiddlePage)}
                      className="page-btn"
                      id={PageInfo.MiddlePage + "-page-btn"}
                    >
                      {PageInfo.MiddlePage}
                    </button>
                  )}
                  {parseInt(PageInfo.MiddlePage + 1) >=
                  PageInfo.LastPage ? null : (
                    <button
                      onClick={() =>
                        requestPageNumber(parseInt(PageInfo.MiddlePage + 1))
                      }
                      className="page-btn "
                      id={parseInt(PageInfo.MiddlePage + 1) + "-page-btn"}
                    >
                      {parseInt(PageInfo.MiddlePage + 1)}
                    </button>
                  )}
                  {!PageInfo.LastDotsShown ? <p>...</p> : null}
                  <button
                    onClick={() => requestPageNumber(PageInfo.LastPage)}
                    className="page-btn"
                    id={PageInfo.LastPage + "-page-btn"}
                  >
                    {PageInfo.LastPage}
                  </button>
                </React.Fragment>
              )}
            </React.Fragment>

            {Pages.length === 1 ? (
              <button
                onClick={() => requestNextPage()}
                id="next-page"
                className="page-btn page-btn-disabled"
              >
                <i className="feather-chevron-right"></i>
              </button>
            ) : (
              <button
                onClick={() => requestNextPage()}
                id="next-page"
                className="page-btn"
              >
                <i className="feather-chevron-right"></i>
              </button>
            )}
          </section>
          <div className="row-count-select">
            <p className="row-info">{translateText("items_per_page")}</p>
            <Select
              Initial={"6"}
              Options={SizeOptions}
              IsWithId
              PreSelected
              PreSelectedId="6"
              Id={"row-per-page"}
              ChangeHandler={() =>
                setTimeout(() => {
                  handleSizeChange();
                }, 100)
              }
              ValidationError=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vacancies;
